<script setup lang="ts">
    import AppControls from "@/components/tellscale/utilities/AppControls.vue";
    import LegalNav from "@/components/tellscale/LegalNav.vue";
</script>

<template>
    <div class="h-screen w-screen flex flex-col">
        <div class="flex p-3">
            <AppControls class="ml-auto"/>
        </div>

        <div class="flex grow justify-center items-center px-3">
            <slot/>
        </div>

        <div class="flex justify-center p-5">
            <LegalNav/>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>